import React from "react";
import approachImage from "../assets/why-choose-us2.jpg";

const points = [
  "Bank-Grade Security: End-to-end encryption across all interactions with Multi-Factor Authentication (MFA)",
  "Strict Compliance: Fully compliant with strict healthcare data regulations like HIPAA and GDPR",
  "High Performance: Load balancing and caching for smooth performance under high traffic",
  "Inclusive Accessibility: Multi-language support and WCAG-compliant design for users with impairments",
  "Omnichannel Experience: A fully responsive, clean, and intuitive UI across mobile, tablet, and desktop devices",
];

const Approach = () => (
  <>
    <style>{`
      @keyframes slideInUp {
        from {
          opacity: 0;
          transform: translateY(40px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      @keyframes slideInDown {
        from {
          opacity: 0;
          transform: translateY(-30px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      @keyframes pulse {
        0%, 100% { opacity: 1; }
        50% { opacity: 0.7; }
      }

      @keyframes slideInLeft {
        from {
          opacity: 0;
          transform: translateX(-30px);
        }
        to {
          opacity: 1;
          transform: translateX(0);
        }
      }

      .approach-badge {
        animation: slideInDown 0.6s ease-out;
      }

      .approach-title {
        animation: slideInUp 0.8s ease-out 0.2s both;
      }

      .approach-text {
        animation: slideInUp 0.8s ease-out 0.4s both;
      }

      .approach-list {
        animation: slideInUp 0.8s ease-out 0.6s both;
      }

      .approach-item {
        animation: slideInLeft 0.6s ease-out;
        transition: all 0.3s ease;
      }

      .approach-item:nth-child(1) { animation-delay: 0.7s; }
      .approach-item:nth-child(2) { animation-delay: 0.8s; }
      .approach-item:nth-child(3) { animation-delay: 0.9s; }
      .approach-item:nth-child(4) { animation-delay: 1s; }
      .approach-item:nth-child(5) { animation-delay: 1.1s; }

      .approach-item:hover {
        transform: translateX(15px);
        padding-left: 20px;
      }

      .approach-item:hover .approach-check {
        animation: pulse 0.5s ease-out;
        color: #0D9DAD;
        text-shadow: 0 0 10px rgba(13, 157, 173, 0.5);
      }

      .approach-check {
        transition: all 0.3s ease;
      }

      .cyan-pulse {
        animation: pulse 2s ease-in-out infinite;
      }
    `}</style>

    <section
      className="relative overflow-hidden min-h-screen flex items-center justify-center py-24"
      style={{
        backgroundImage: `url(${approachImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}
    >
      {/* Dark gradient overlay for text readability */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/60 to-black/70" />

      {/* Content */}
      <div className="relative max-w-5xl mx-auto px-6 py-12">
        <div>
          <span className="approach-badge inline-flex items-center gap-2 bg-white/20 border border-white/40 rounded-full px-4 py-2 text-sm font-semibold text-white mb-6 backdrop-blur-md">
            <span className="w-2 h-2 bg-[#0D9DAD] rounded-full cyan-pulse" />
            Technical Excellence
          </span>
          <h2 className="approach-title text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-8 leading-tight">Built for Speed, Safety, and Seamless Access</h2>
          <p className="approach-text text-white/90 text-xl leading-relaxed mb-10 max-w-3xl">
            HelaDoc is engineered for high performance, robust security, and an inclusive user experience. We ensure real-time AI processing and low-latency consultations while maintaining strict compliance with global healthcare regulations.
          </p>
          <ul className="approach-list space-y-5 max-w-3xl">
            {points.map((p, idx) => (
              <li key={idx} className="approach-item flex items-start gap-4 text-lg">
                <span className="approach-check text-[#0D9DAD] font-bold text-2xl flex-shrink-0 mt-0.5">✓</span>
                <span className="text-white/90 leading-relaxed transition-all duration-300">{p}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  </>
);

export default Approach;
